import React from "react";
import dynamic from "next/dynamic";

const ImageUI = dynamic(() => import("@/common/UI/Image"));

function InfoIconSection(props) {
  const { icons, siteConfig } = props;
  return (
    <>
      <section
        style={{
          backgroundColor: siteConfig?.brandButtonPressedColor?.hex,
        }}
        className="py-10"
      >
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-white">
            {icons?.map((item, index) => {
              return (
                <div
                  className="flex contain-image items-center justify-start md:justify-center relative"
                  key={index}
                >
                  <ImageUI
                    src={item?.webp}
                    alt={item?.alt}
                    width={22}
                    height={22}
                  />
                  <h6 className="h6-web w-full text-[0.75rem] tracking-[0.2em] text-white uppercase ml-6">
                    {item?.title}
                  </h6>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default InfoIconSection;
